import React, { useState } from 'react';
import { CreditCard } from 'lucide-react';
import { BillingCycle, SubscriptionPlanId } from '../../types/subscription';
import {
  createXpaySubscriptionCheckout,
  redirectToXpay,
} from '../../services/xpayService';
import Button from '../ui/Button';
import Surface from '../ui/Surface';

interface XpayCheckoutProps {
  planId: SubscriptionPlanId;
  billingCycle: BillingCycle;
  onError?: (err: unknown) => void;
}

const XpayCheckout: React.FC<XpayCheckoutProps> = ({
  planId,
  billingCycle,
  onError,
}) => {
  const [loading, setLoading] = useState(false);

  const handleCheckout = async () => {
    setLoading(true);
    try {
      const order = await createXpaySubscriptionCheckout(planId, billingCycle);
      await redirectToXpay(order.redirectUrl);
    } catch (error) {
      setLoading(false);
      console.error('XPay subscription error:', error);
      onError?.(error);
    }
  };

  return (
    <Surface padding='md' className='border-emerald-100 bg-emerald-50 dark:border-emerald-900 dark:bg-emerald-950/30'>
      <div className='flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between'>
        <div>
          <p className='font-semibold text-emerald-950 dark:text-emerald-100'>
            XPay
          </p>
          <p className='mt-1 text-xs text-emerald-800 dark:text-emerald-200'>
            سيتم تحويلك إلى صفحة XPay الآمنة، وسيتم تفعيل الاشتراك بعد تأكيد webhook الخادمي.
          </p>
        </div>
        <Button
          onClick={handleCheckout}
          loading={loading}
          leadingIcon={<CreditCard className='h-4 w-4' />}
          className='shrink-0'
        >
          الدفع عبر XPay
        </Button>
      </div>
    </Surface>
  );
};

export default XpayCheckout;
